/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Import_SuccessInputs */

const en_transcript_import_success = /** @type {(inputs: Transcript_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcript import successful`)
};

const fr_transcript_import_success = /** @type {(inputs: Transcript_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation de transcription réussie`)
};

const de_transcript_import_success = /** @type {(inputs: Transcript_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transkriptimport erfolgreich`)
};

const it_transcript_import_success = /** @type {(inputs: Transcript_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione della trascrizione riuscita`)
};

const ru_transcript_import_success = /** @type {(inputs: Transcript_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт стенограммы пройден успешно.`)
};

const es_transcript_import_success = /** @type {(inputs: Transcript_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importación de transcripción exitosa`)
};

const zh_cn2_transcript_import_success = /** @type {(inputs: Transcript_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成绩单导入成功`)
};

const ja_transcript_import_success = /** @type {(inputs: Transcript_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トランスクリプトのインポートに成功しました`)
};

const hi_transcript_import_success = /** @type {(inputs: Transcript_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिलेख आयात सफल रहा`)
};

const pt_pt2_transcript_import_success = /** @type {(inputs: Transcript_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação da transcrição concluída com sucesso.`)
};

/**
* | output |
* | --- |
* | "Transcript import successful" |
*
* @param {Transcript_Import_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_import_success = /** @type {((inputs?: Transcript_Import_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Import_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_import_success(inputs)
	if (locale === "de") return de_transcript_import_success(inputs)
	if (locale === "it") return it_transcript_import_success(inputs)
	if (locale === "ru") return ru_transcript_import_success(inputs)
	if (locale === "es") return es_transcript_import_success(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_import_success(inputs)
	if (locale === "ja") return ja_transcript_import_success(inputs)
	if (locale === "hi") return hi_transcript_import_success(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_import_success(inputs)
	return en_transcript_import_success(inputs)
});